/**
 * FieldNames used as the name prop in Redux-Form Fields
 */
export enum FieldNames {
  /* Verified and tagged */
  /* Unverified and untagged */
  accountBalance                           = 'accountBalance',
  accountFinancialInstitution              = 'accountFinancialInstitution',
  accountSummary                           = 'accountSummary',
  accountType                              = 'accountType',
  acknowledgePreApproval                   = 'acknowledgePreApproval',
  acquiredYear                             = 'acquiredYear',
  additionalIncome                         = 'additionalIncome',
  additionalLeasingAnticipated             = 'additionalLeasingAnticipated',
  addlProperties                           = 'additionalProperties',
  age                                      = 'age',
  agEquipmentType                          = 'agEquipmentType',
  agPropertyIdentity                       = 'agPropertyIdentity',
  agPropertyType                           = 'agPropertyType',
  ageLimit                                 = 'ageLimit',
  agreementYN                              = 'purchaseAgreement',
  amountToFinance                          = 'amountToFinance',
  answeredQuestions                        = 'answeredQuestions',
  apr                                      = 'apr',
  assets                                   = 'assets',
  assetSummary                             = 'assetSummary',
  assetTotalValue                          = 'assetTotalValue',
  assistedYN                               = 'assistedYN',
  attorneyName                             = 'attorneyName',
  autoPurchasePlan                         = 'autoPurchasePlan',
  autoHighLimitPercent                     = 'autoHighLimitPercent',
  autoLoanMinLtvAction                     = 'autoLoanMinLtvAction',
  avmHomeValue                             = 'avmHomeValue',
  avmHomeValueHighLimit                    = 'avmHomeValueHighLimit',
  avmHomeValueLowLimit                     = 'avmHomeValueLowLimit',
  avmReport                                = 'avmReport',
  autoRetailValue                          = 'autoRetailValue',
  bankruptAge                              = 'bankruptAge',
  bankruptType                             = 'bankruptType',
  bankOrLessorAccountNumber                = 'bankOrLessorAccountNumber',
  bankOrLessorCity                         = 'bankOrLessorCity',
  bankOrLessorContact                      = 'bankOrLessorContact',
  bankOrLessorName                         = 'bankOrLessorName',
  bankOrLessorPhone                        = 'bankOrLessorPhone',
  bankOrLessorState                        = 'bankOrLessorState',
  bankOrLessorStreet                       = 'bankOrLessorStreet',
  bankOrLessorStreet2                      = 'bankOrLessorStreet2',
  bankOrLessorZip                          = 'bankOrLessorZip',
  borrowedDownAmount                       = 'borrowedDownAmount',
  borrowerId                               = 'borrowerId',
  borrowerJobDurationAlgorithm             = 'borrowerJobDurationAlgorithm',
  borrowerJobDurationMonths                = 'borrowerJobDurationMonths',
  branchEmployee                           = 'branchEmployee',
  branchNumber                             = 'branchNumber',
  brokerLoanOfficerCompanyNMLS             = 'brokerLoanOfficerCompanyNMLS',
  brokerLoanOfficerPhone                   = 'brokerLoanOfficerPhone',
  brokerLoanOfficerEmail                   = 'brokerLoanOfficerEmail',
  brokerLoanOfficerFirstName               = 'brokerLoanOfficerFirstName',
  brokerLoanOfficerLastName                = 'brokerLoanOfficerLastName',
  buildingContactName                      = 'buildingContactName',
  buildingContactPhone                     = 'buildingContactPhone',
  buildingSquareFootage                    = 'buildingSquareFootage',
  builtYear                                = 'builtYear',
  buyingProcess                            = 'buyingProcess',
  buildingUnits                            = 'buildingUnits',
  cashDown                                 = 'cashDown',
  cashOutMaxLTV                            = 'cashOutMaxLTV',
  captcha                                  = 'captcha',
  cashOut                                  = 'cashOut',
  canVerifyOfIncomeEmployment              = 'canVerifyOfIncomeEmployment',
  canReceiveInsuranceQuote                 = 'canReceiveInsuranceQuote',
  changedIncomeYN                          = 'changedIncomeYN',
  citizenshipType                          = 'citizenshipType',
  coBorrowerAdditionalIncome               = 'coBorrowerAdditionalIncome',
  coBorrowerAge                            = 'coBorrowerAge',
  coBorrowerAssetTotalValue                = 'coBorrowerAssetTotalValue',
  coBorrowerChangedIncomeYN                = 'coBorrowerChangedIncomeYN',
  coBorrowerCitizenshipType                = 'coBorrowerCitizenshipType',
  coBorrowerDOB                            = 'coBorrowerDateOfBirth',
  coBorrowerEmail                          = 'coBorrowerEmail',
  coBorrowerEmployBase                     = 'coBorrowerEmployBase',
  coBorrowerEmployBonus                    = 'coBorrowerEmployBonus',
  coBorrowerEmployCity                     = 'coBorrowerEmployCity',
  coBorrowerEmployCommission               = 'coBorrowerEmployCommission',
  coBorrowerEmployCompanyName              = 'coBorrowerEmployCompanyName',
  coBorrowerEmploymentType                 = 'coBorrowerEmploymentType',
  coBorrowerEmployOvertime                 = 'coBorrowerEmployOvertime',
  coBorrowerEmployOwnershipShare           = 'coBorrowerEmployOwnershipShare',
  coBorrowerEmployPartyTransaction         = 'coBorrowerEmployPartyTransaction',
  coBorrowerEmployPhone                    = 'coBorrowerEmployPhone',
  coBorrowerEmployPrevCity                 = 'coBorrowerEmployPrevCity',
  coBorrowerEmployPrevEnd                  = 'coBorrowerEmployPrevEnd',
  coBorrowerEmployPrevName                 = 'coBorrowerEmployPrevName',
  coBorrowerEmployPrevStart                = 'coBorrowerEmployPrevStart',
  coBorrowerEmployPrevState                = 'coBorrowerEmployPrevState',
  coBorrowerEmployPrevStreet               = 'coBorrowerEmployPrevStreet',
  coBorrowerEmployPrevStreet2              = 'coBorrowerEmployPrevStreet2',
  coBorrowerEmployPrevTitle                = 'coBorrowerEmployPrevTitle',
  coBorrowerEmployPrevZip                  = 'coBorrowerEmployPrevZip',
  coBorrowerEmployStart                    = 'coBorrowerEmployStart',
  coBorrowerEmployState                    = 'coBorrowerEmployState',
  coBorrowerEmployStreet                   = 'coBorrowerEmployStreet',
  coBorrowerEmployStreet2                  = 'coBorrowerEmployStreet2',
  coBorrowerEmployTitle                    = 'coBorrowerEmployTitle',
  coBorrowerEmployZip                      = 'coBorrowerEmployZip',
  coBorrowerFirstName                      = 'coBorrowerFirstName',
  coBorrowerId                             = 'coBorrowerId',
  coBorrowerIncomeMonthly                  = 'coBorrowerIncomeMonthly',
  coBorrowerIncomeOnDeclineYN              = 'coBorrowerIncomeOnDecline',
  coBorrowerIncomeVerifiable               = 'coBorrowerIncomeVerifiable',
  coBorrowerLastName                       = 'coBorrowerLastName',
  coBorrowerLineOfWorkYears                = 'coBorrowerLineOfWorkYears',
  coBorrowerLineOfWorkMonths               = 'coBorrowerLineOfWorkMonths',
  coBorrowerLivingMonthlyRentAmount        = 'coBorrowerLivingMonthlyRentAmount',
  coBorrowerLivingPropertyCity             = 'coBorrowerLivingPropertyCity',
  coBorrowerLivingPropertyState            = 'coBorrowerLivingPropertyState',
  coBorrowerLivingPropertyStreet           = 'coBorrowerLivingPropertyStreet',
  coBorrowerLivingPropertyStreet2          = 'coBorrowerLivingPropertyStreet2',
  coBorrowerLivingPropertyType             = 'coBorrowerLivingPropertyType',
  coBorrowerLivingPropertyZip              = 'coBorrowerLivingPropertyZip',
  coBorrowerLivingRentOrOwn                = 'coBorrowerLivingRentOrOwn',
  coBorrowerMaritalStatus                  = 'coBorrowerMarried',
  coBorrowerMiddleName                     = 'coBorrowerMiddleName',
  coBorrowerMilitaryExperience             = 'coBorrowerMilitaryExperience',
  coBorrowerOnTitle                        = 'hasCoBorrowerOnTitle',
  coBorrowerOtherIncome                    = 'coBorrowerOtherIncome',
  coBorrowerPhone                          = 'coBorrowerPhone',
  coBorrowerRealEstateTotalValue           = 'coBorrowerRealEstateTotalValue',
  coBorrowerRetirementIncome               = 'coBorrowerRetirementIncome',
  coBorrowerSameAddress                    = 'coBorrowerSameAddress',
  coBorrowerSsn                            = 'coBorrowerSsn',
  coBorrowerSuffixName                     = 'coBorrowerSuffixName',
  coBorrowerYN                             = 'hasCoBorrower',
  commercialBridgeOrCredit                 = 'commercialBridgeOrCredit',
  commercialBusinessAnnualInterestExpense  = 'commercialBusinessAnnualInterestExpense',
  commercialBusinessCashAndEquivalents     = 'commercialBusinessCashAndEquivalents',
  commercialBusinessCheckingAccountBalance = 'commercialBusinessCheckingAccountBalance',
  commercialBusinessEBITA                  = 'commercialBusinessEBITA',
  commercialBusinessCounty                 = 'commercialBusinessCounty',
  commercialBusinessEmail                  = 'commercialBusinessEmail',
  commercialBusinessName                   = 'commercialBusinessName',
  commercialBusinessNeed                   = 'commercialBusinessNeed',
  commercialBusinessNetWorth               = 'commercialBusinessNetWorth',
  commercialBusinessOwnershipType          = 'commercialBusinessOwnershipType',
  commercialBusinessStartDate              = 'commercialBusinessStartDate',
  commercialBusinessTitle                  = 'commercialBusinessTitle',
  commercialBusinessTotalAssets            = 'commercialBusinessTotalAssets',
  commercialBusinessTotalLiabilities       = 'commercialBusinessTotalLiabilities',
  commercialBusinessTotalSales             = 'commercialBusinessTotalSales',
  commercialBusinessType                   = 'commercialBusinessType',
  commercialBusinessTypeOther              = 'commercialBusinessTypeOther',
  commercialCensusTract                    = 'commercialCensusTract',
  commercialCity                           = 'commercialCity',
  commercialCollateralDescription          = 'commercialCollateralDescription',
  commercialCollateralList                 = 'commercialCollateralList',
  commercialCollateralValue                = 'commercialCollateralValue',
  commercialDBA                            = 'commercialDBA',
  commercialDescription                    = 'commercialDescription',
  commercialEmployCoBorrowerSameBusiness   = 'commercialEmployCoBorrowerSameBusiness',
  commercialEquipmentDescription           = 'commercialEquipmentDescription',
  commercialEquipmentList                  = 'commercialEquipmentList',
  commercialEquipmentLocation              = 'commercialEquipmentLocation',
  commercialExpectedCost                   = 'commercialExpectedCost',
  commercialPropertyTaxExempt              = 'commercialPropertyTaxExempt',
  commercialSalesTaxExempt                 = 'commercialSalesTaxExempt',
  commercialTaxExemptReason                = 'commercialTaxExemptReason',
  commercialLoanPurpose                    = 'commercialLoanPurpose',
  commercialEmploySameBusiness             = 'commercialEmploySameBusiness',
  commercialEmployeeCount                  = 'commercialEmployeeCount',
  commercialEntityType                     = 'commercialEntityType',
  commercialEquipmentOrInventory           = 'commercialEquipmentOrInventory',
  commercialLifeExpectancy                 = 'commercialLifeExpectancy',
  commercialLienBalance                    = 'commercialLienBalance',
  commercialLoanHolder                     = 'commercialLoanHolder',
  commercialLoanTiming                     = 'commercialLoanTiming',
  commercialMailingCity                    = 'commercialMailingCity',
  commercialMailingState                   = 'commercialMailingState',
  commercialMailingStreet                  = 'commercialMailingStreet',
  commercialMailingStreet2                 = 'commercialMailingStreet2',
  commercialMailingZip                     = 'commercialMailingZip',
  commercialManagementList                 = 'commercialManagementList',
  commercialNAICSCode                      = 'commercialNAICSCode',
  commercialOwnerList                      = 'commercialOwnerList',
  commercialPhone                          = 'commercialPhone',
  commercialProfitExplanation              = 'commercialProfitExplanation',
  commercialPropertyType                   = 'commercialPropertyType',
  commercialProfitTrend3                   = 'commercialProfitTrend3',
  commercialRevenueExplanation             = 'commercialRevenueExplanation',
  commercialRevenueLastYear                = 'commercialRevenueLastYear',
  commercialRevenueTrend3                  = 'commercialRevenueTrend3',
  commercialSameBusiness                   = 'commercialSameBusiness',
  commercialSameMailingAddress             = 'commercialSameMailingAddress',
  commercialState                          = 'commercialState',
  commercialStateOfIncorporation           = 'commercialStateOfIncorporation',
  commercialStateOfOrganization            = 'commercialStateOfOrganization',
  commercialStreet                         = 'commercialStreet',
  commercialStreet2                        = 'commercialStreet2',
  commercialTIN                            = 'commercialTIN',
  commercialVehicleList                    = 'commercialVehicleList',
  commercialVehicleTotalPurchasePrice      = 'commercialVehicleTotalPurchasePrice',
  commercialVehicleTotalDownPayment        = 'commercialVehicleTotalDownPayment',
  commercialVehicleTotalTradeInValue       = 'commercialVehicleTotalTradeInValue',
  commercialWebsite                        = 'commercialWebsite',
  commercialYearStarted                    = 'commercialYearStarted',
  commercialZip                            = 'commercialZip',
  constructionCost                         = 'constructionCost',
  constructionHomeType                     = 'constructionHomeType',
  constructionLoanType                     = 'constructionLoanType',
  constructionLandAcquired                 = 'constructionLandAcquired',
  constructionLandCost                     = 'constructionLandCost',
  constructionLandOwner                    = 'constructionLandOwner',
  constructionRoofingType                  = 'constructionRoofingType',
  creditAuthorize                          = 'creditAuthorize',
  creditBoosterLoanOption                  = 'creditBoosterLoanOption',
  creditCardType                           = 'creditCardType',
  creditCardLimit                          = 'creditCardLimit',
  creditReportId                           = 'creditReportId',
  creditScore                              = 'fico',
  currentDebtRating                        = 'currentDebtRating',
  currentInterestRate                      = 'currentInterestRate',
  currentLoanType                          = 'currentLoanType',
  currentLoanTerm                          = 'currentLoanTerm',
  currentMonthlyPayment                    = 'currentMonthlyPayment',
  currentZoningClassification              = 'currentZoningClassification',
  dateOfBirth                              = 'dateOfBirth',
  decBorrower                              = 'decBorrower',
  decCoBorrower                            = 'decCoBorrower',
  decRelative                              = 'decRelative',
  declarations                             = 'declarations',
  downDollar                               = 'downPaymentDollar',
  downPercent                              = 'downPaymentPercent',
  economicInjuryDisasterLoans              = 'economicInjuryDisasterLoans',
  eidlBalance                              = 'eidlBalance',
  eidlBankName                             = 'eidlBankName',
  eidlCollateral                           = 'eidlCollateral',
  eidlLoanType                             = 'eidlLoanType',
  email                                    = 'email',
  employBase                               = 'employBase',
  employBonus                              = 'employBonus',
  employCity                               = 'employCity',
  employCommission                         = 'employCommission',
  employCompanyName                        = 'employCompanyName',
  employmentType                           = 'employmentType',
  employOvertime                           = 'employOvertime',
  employOwnershipShare                     = 'employOwnershipShare',
  employPartyTransaction                   = 'employPartyTransaction',
  employPhone                              = 'employPhone',
  employPrevCity                           = 'employPrevCity',
  employPrevEnd                            = 'employPrevEnd',
  employPrevName                           = 'employPrevName',
  employPrevStart                          = 'employPrevStart',
  employPrevState                          = 'employPrevState',
  employPrevStreet                         = 'employPrevStreet',
  employPrevStreet2                        = 'employPrevStreet2',
  employPrevTitle                          = 'employPrevTitle',
  employPrevZip                            = 'employPrevZip',
  employStart                              = 'employStart',
  employState                              = 'employState',
  employStreet                             = 'employStreet',
  employStreet2                            = 'employStreet2',
  employTitle                              = 'employTitle',
  employZip                                = 'employZip',
  equipmentAdditionReason                  = 'equipmentAdditionReason',
  equipmentCondition                       = 'equipmentCondition',
  equipmentCost                            = 'equipmentCost',
  equipmentDeliveryDate                    = 'equipmentDeliveryDate',
  equipmentUseDepartment                   = 'equipmentUseDepartment',
  escrowUsage                              = 'escrowUsage',
  ethnicity                                = 'ethnicity',
  ethnicityHispanic                        = 'ethnicityHispanic',
  ethnicityOther                           = 'ethnicityOther',
  excludedQuestions                        = 'excludedQuestions',
  existingEquipmentAge                     = 'existingEquipmentAge',
  existingLoanNumber                       = 'existingLoanNumber',
  expectedClosingDate                      = 'expectedClosingDate',
  expectedLumpSum                          = 'expectedLumpSum',
  expectedOwnerOccupancy                   = 'expectedOwnerOccupancy',
  expectedVendorPaymentDate                = 'expectedVendorPaymentDate',
  fee                                      = 'fee',
  financialStatementAccountType            = 'financialStatementAccountType',
  financialStatementAmountOwed             = 'financialStatementAmountOwed',
  financialStatementBalanceOwed            = 'financialStatementBalanceOwed',
  financialStatementBeneficiary            = 'financialStatementBeneficiary',
  financialStatementCashAccount            = 'financialStatementCashAccount',
  financialStatementCashValue              = 'financialStatementCashValue',
  financialStatementCreditCards            = 'financialStatementCreditCards',
  financialStatementCreditor               = 'financialStatementCreditor',
  financialStatementCompany                = 'financialStatementCompany',
  financialStatementCurrentBalance         = 'financialStatementCurrentBalance',
  financialStatementDescription            = 'financialStatementDescription',
  financialStatementFaceValue              = 'financialStatementFaceValue',
  financialStatementFinancialInstitution   = 'financialStatementFinancialInstitution',
  financialStatementHasCashAccount         = 'financialStatementHasCashAccount',
  financialStatementHasCreditCard          = 'financialStatementHasCreditCard',
  financialStatementHasLifeInsurance       = 'financialStatementHasLifeInsurance',
  financialStatementHasLoan                = 'financialStatementHasLoan',
  financialStatementHasMortgage            = 'financialStatementHasMortgage',
  financialStatementHasNote                = 'financialStatementHasNote',
  financialStatementHasPersonalProperty    = 'financialStatementHasPersonalProperty',
  financialStatementHasRealEstate          = 'financialStatementHasRealEstate',
  financialStatementHasRetirementAccount   = 'financialStatementHasRetirementAccount',
  financialStatementHasStock               = 'financialStatementHasStock',
  financialStatementHasSpouse              = 'financialStatementHasSpouse',
  financialStatementHasTaxes               = 'financialStatementHasTaxes',
  financialStatementJointAccount           = 'financialStatementJointAccount',
  financialStatementLifeInsurance          = 'financialStatementLifeInsurance',
  financialStatementLocation               = 'financialStatementLocation',
  financialStatementLoans                  = 'financialStatementLoans',
  financialStatementMarketValue            = 'financialStatementMarketValue',
  financialStatementMaturityDate           = 'financialStatementMaturityDate',
  financialStatementMonthlyPayment         = 'financialStatementMonthlyPayment',
  financialStatementMortgages              = 'financialStatementMortgages',
  financialStatementNotePurpose            = 'financialStatementNotePurpose',
  financialStatementNotes                  = 'financialStatementNotes',
  financialStatementNumOfShares            = 'financialStatementNumOfShares',
  financialStatementOwingParty             = 'financialStatementOwingParty',
  financialStatementPersonalProperties     = 'financialStatementPersonalProperties',
  financialStatementPersonalType           = 'financialStatementPersonalType',
  financialStatementPurchaseDate           = 'financialStatementPurchaseDate',
  financialStatementRealEstate             = 'financialStatementRealEstate',
  financialStatementSecuredBy              = 'financialStatementSecuredBy',
  financialStatementSecurityName           = 'financialStatementSecurityName',
  financialStatementStocks                 = 'financialStatementStocks',
  financialStatementTaxes                  = 'financialStatementTaxes',
  financialStatementTaxType                = 'financialStatementTaxType',
  financialStatementRetirementAccounts     = 'financialStatementRetirementAccounts',
  financialStatementRetirementType         = 'financialStatementRetirementType',
  financialStatementSpouseFirstName        = 'financialStatementSpouseFirstName',
  financialStatementSpouseMiddleName       = 'financialStatementSpouseMiddleName',
  financialStatementSpouseLastName         = 'financialStatementSpouseLastName',
  financialStatementSpouseSuffixName       = 'financialStatementSpouseSuffixName',
  financialStatementSpousePhone            = 'financialStatementSpousePhone',
  financialStatementSpouseEmail            = 'financialStatementSpouseEmail',
  financialStatementSpouseDateOfBirth      = 'financialStatementSpouseDateOfBirth',
  financialVerificationIntegration         = 'financialVerificationIntegration',
  firstName                                = 'firstName',
  firstPaymentTiming                       = 'firstPaymentTiming',
  forecloseCompleted                       = 'forecloseCompleted',
  grantsOrLoansForLease                    = 'grantsOrLoansForLease',
  hasAddlPropertiesYN                      = 'hasAdditionalProperties',
  hasAutoLoanSpecialCalculation            = 'hasAutoLoanSpecialCalculation',
  hasReverseAgeQuestion                    = 'hasReverseAgeQuestion',
  hasReverseCreditScoreQuestion            = 'hasReverseCreditScoreQuestion',
  hasReverseSummaryInfo                    = 'hasReverseSummaryInfo',
  hasAlimony                               = 'hasAlimony',
  hasAnotherMortgageInProgress             = 'hasAnotherMortgageInProgress',
  hasBankrupt                              = 'hasBankrupt',
  hasBorrowedDown                          = 'hasBorrowedDown',
  hasCommercialBankrupt                    = 'hasCommercialBankrupt',
  hasCommercialCredit                      = 'hasCommercialCredit',
  hasCommercialDebt                        = 'hasCommercialDebt',
  hasCommercialLegalAction                 = 'hasCommercialLegalAction',
  hasCommercialTaxDue                      = 'hasCommercialTaxDue',
  hasCitizenship                           = 'hasCitizenship',
  hasConveyedTitle                         = 'hasConveyedTitle',
  hasCurrentCheckingAccount                = 'hasCurrentCheckingAccount',
  hasDelinquent                            = 'hasDelinquent',
  hasEconomicInjuryDisasterLoan            = 'hasEconomicInjuryDisasterLoan',
  hasEnabledCreditReportOnTurbo            = 'hasEnabledCreditReportOnTurbo',
  hasExitedFinicity                        = 'hasExitedFinicty',
  hasExitedTruv                            = 'hasExitedTruv',
  hasFamilyRelationship                    = 'hasFamilyRelationship',
  hasForeclosed                            = 'hasForeclosed',
  hasGreenCard                             = 'hasGreenCard',
  hasJudgements                            = 'hasJudgements',
  hasLawsuit                               = 'hasLawsuit',
  hasLineOfWorkQuestion                    = 'hasLineOfWorkQuestion',
  hasLoanObligation                        = 'hasLoanObligation',
  hasLoanTypeQuestion                      = 'hasLoanTypeQuestion',
  hasMadeMostRecentMortgagePayment         = 'hasMadeMostRecentMortgagePayment',
  hasNoteEndorsement                       = 'hasNoteEndorsement',
  hasOccupyPrimary                         = 'hasOccupyPrimary',
  hasOtherManagement                       = 'hasOtherManagement',
  hasOtherLienOnProperty                   = 'hasOtherLienOnProperty',
  hasWarningForLoanAmountReduction         = 'hasWarningForLoanAmountReduction',
  hasWarningForRateChange                  = 'hasWarningForRateChange',
  hasWarningForProgramNotAvailable         = 'hasWarningForProgramNotAvailable',
  isCollectingMailingAddress               = 'isCollectingMailingAddress',
  isDefaultedHMDAAnswer                    = 'isDefaultedHMDAAnswer',
  isHideGovtMonitoring                     = 'isHideGovtMonitoring',
  isHideGovtMonitoringHelocArm             = 'isHideGovtMonitoringHelocArm',
  isHideDependentsAges                     = 'isHideDependentsAges',
  isMailingDifferent                       = 'isMailingDifferent',
  isOwningHomeOutright                     = 'isOwningHomeOutright',
  isOwningOtherHomes                       = 'isOwningOtherHomes',
  isFinancialVerificationComplete          = 'isFinancialVerificationComplete',
  isIncomeVerificationComplete             = 'isIncomeVerificationComplete',
  isAssetVerificationComplete              = 'isAssetVerificationComplete',
  isVehicleSalvageTitle                    = 'isVehicleSalvageTitle',
  hasLatePropertyCharges                   = 'hasLatePropertyCharges',
  hasOtherTaxBillsDue                      = 'hasOtherTaxBillsDue',
  hasOwnerInterest                         = 'hasOwnerInterest',
  hasSelectedNewHome                       = 'hasSelectedNewHome',
  hasShortSale                             = 'hasShortSale',
  hasUniquePersonalLoanProgram             = 'hasUniquePersonalLoanProgram',
  hasUniqueHomeEquityProgram               = 'hasUniqueHomeEquityProgram',
  hasAssetFinancialInstitution             = 'hasAssetFinancialInstitution',
  homeChosenYN                             = 'homeChosen',
  homeEquityDebtConsolidationType          = 'homeEquityDebtConsolidationType',
  homeEquityLoanPurpose                    = 'homeEquityLoanPurpose',
  homeEquityLoanPurposeOther               = 'homeEquityLoanPurposeOther',
  homeSoldYN                               = 'homeSold',
  homeStories                              = 'homeStories',
  homeValue                                = 'propertyAppraisedValue',
  hubSpotContactId                         = 'hubSpotContactId',
  incomeMonthly                            = 'incomeMonthly',
  incomeOnDeclineYN                        = 'incomeOnDecline',
  incomeSource                             = 'incomeSource',
  incomeVerifiable                         = 'incomeVerifiable',
  initialMortgageInsurance                 = 'initialMortgageInsurance',
  insuranceAgentEmail                      = 'insuranceAgentEmail',
  insuranceAgentFirstName                  = 'insuranceAgentFirstName',
  insuranceAgentLastName                   = 'insuranceAgentLastName',
  insuranceAgentMiddleName                 = 'insuranceAgentMiddleName',
  insuranceAgentPhone                      = 'insuranceAgentPhone',
  insuranceAgentSuffixName                 = 'insuranceAgentSuffixName',
  insuranceCompanyCity                     = 'insuranceCompanyCity',
  insuranceCompanyName                     = 'insuranceCompanyName',
  insuranceCompanyState                    = 'insuranceCompanyState',
  insuranceCompanyStreet                   = 'insuranceCompanyStreet',
  insuranceCompanyStreet2                  = 'insuranceCompanyStreet2',
  insuranceCompanyZip                      = 'insuranceCompanyZip',
  isAffinityProgram                        = 'isAffinityProgram',
  isAGExistingCustomer                     = 'isAGExistingCustomer',
  isCommercialExistingCustomer             = 'isCommercialExistingCustomer',
  isFromDealer                             = 'isFromDealer',
  isBorrowerSsnValid                       = 'isBorrowerSsnValid',
  isCoBorrowerSsnValid                     = 'isCoBorrowerSsnValid',
  isBorrowerSsnEmpty                       = 'isBorrowerSsnEmpty',
  isCoBorrowerSsnEmpty                     = 'isCoBorrowerSsnEmpty',
  isBothSsnMatch                           = 'isBothSsnMatch',
  isHidePurchasePropertyAddress            = 'isHidePurchasePropertyAddress',
  landingLoanType                          = 'landingLoanType',
  landSize                                 = 'landSize',
  lastName                                 = 'lastName',
  lawFirmCity                              = 'lawFirmCity',
  lawFirmName                              = 'lawFirmName',
  lawFirmPhone                             = 'lawFirmPhone',
  lawFirmState                             = 'lawFirmState',
  lawFirmStreet                            = 'lawFirmStreet',
  lawFirmStreet2                           = 'lawFirmStreet2',
  lawFirmZip                               = 'lawFirmZip',
  leaseFundSource                          = 'leaseFundSource',
  lesseeBillingCity                        = 'lesseeBillingCity',
  lesseeBillingState                       = 'lesseeBillingState',
  lesseeBillingStreet                      = 'lesseeBillingStreet',
  lesseeBillingStreet2                     = 'lesseeBillingStreet2',
  lesseeBillingZip                         = 'lesseeBillingZip',
  lesseeContactFirstName                   = 'lesseeContactFirstName',
  lesseeContactMiddleName                  = 'lesseeContactMiddleName',
  lesseeContactLastName                    = 'lesseeContactLastName',
  lesseeContactSuffixName                  = 'lesseeContactSuffixName',
  lesseeContactTitle                       = 'lesseeContactTitle',
  lesseeTaxId                              = 'lesseeTaxId',
  livingArea                               = 'livingArea',
  liabilityAmount                          = 'liabilityAmount',
  liabilityBalance                         = 'liabilityBalance',
  liabilityExclusionReason                 = 'liabilityExclusionReason',
  liabilityName                            = 'liabilityName',
  liabilityStatus                          = 'liabilityStatus',
  liabilityUsage                           = 'liabilityUsage',
  liabilityYearAssociate                   = 'liabilityYearAssociate',
  liabilityYearInsure                      = 'liabilityYearInsure',
  liabilityYearTaxes                       = 'liabilityYearTaxes',
  liabilityCombinedNumberOtherHomes        = 'liabilityCombinedNumberOtherHomes',
  liabilityCombinedYearAssociate           = 'liabilityCombinedYearAssociate',
  liabilityCombinedYearInsure              = 'liabilityCombinedYearInsure',
  liabilityCombinedYearTaxes               = 'liabilityCombinedYearTaxes',
  lineOfCredit                             = 'lineOfCredit',
  lineOfWorkMonths                         = 'lineOfWorkMonths',
  lineOfWorkYears                          = 'lineOfWorkYears',
  order                                    = 'order',
  listingPrice                             = 'listingPrice',
  livingEscrowUsage                        = 'livingEscrowUsage',
  livingMonthlyMortgage                    = 'livingMonthlyMortgage',
  livingMonthlyRentAmount                  = 'livingMonthlyRentAmount',
  livingOccupancyStart                     = 'livingOccupancyStart',
  livingPrevPropertyCity                   = 'livingPrevPropertyCity',
  livingPrevPropertyState                  = 'livingPrevPropertyState',
  livingPrevPropertyStreet                 = 'livingPrevPropertyStreet',
  livingPrevPropertyStreet2                = 'livingPrevPropertyStreet2',
  livingPrevPropertyZip                    = 'livingPrevPropertyZip',
  livingPrevRentOrOwn                      = 'livingPrevRentOrOwn',
  livingPrevOccupancyStart                 = 'livingPrevOccupancyStart',
  livingPropertyCity                       = 'livingPropertyCity',
  livingPropertyId                         = 'livingPropertyId',
  livingPropertyState                      = 'livingPropertyState',
  livingPropertyStreet                     = 'livingPropertyStreet',
  livingPropertyStreet2                    = 'livingPropertyStreet2',
  livingPropertyType                       = 'livingPropertyType',
  livingPropertyUsage                      = 'livingPropertyUsage',
  livingPropertyZip                        = 'livingPropertyZip',
  livingRentOrOwn                          = 'livingRentOrOwn',
  livingSituation                          = 'livingSituation',
  livingYearAssociate                      = 'livingYearAssociate',
  livingYearAssociateId                    = 'livingYearAssociateId',
  livingYearInsure                         = 'livingYearInsure',
  livingYearInsureId                       = 'livingYearInsureId',
  livingYearTaxes                          = 'livingYearTaxes',
  livingYearTaxesId                        = 'livingYearTaxesId',
  loanAmount                               = 'loanAmount',
  loanOfficer                              = 'loanOfficer',
  loanPurpose                              = 'loanPurpose',
  loanRenewalDate                          = 'loanRenewalDate',
  loanTerm                                 = 'loanTerm',
  loanTermDesired                          = 'loanTermDesired',                            //auto-loan
  loanType                                 = 'loanType',
  lowFicoLimit                             = 'lowFicoLimit',
  lowFicoSecondaryHomeLimit                = 'lowFicoSecondaryHomeLimit',
  mailingCity                              = 'mailingCity',
  mailingState                             = 'mailingState',
  mailingStreet                            = 'mailingStreet',
  mailingStreet2                           = 'mailingStreet2',
  mailingZip                               = 'mailingZip',
  managementFirstName                      = 'managementFirstName',
  managementLastName                       = 'managementLastName',
  managementMiddleName                     = 'managementMiddleName',
  managementSuffixName                     = 'managementSuffixName',
  managementTitleHeld                      = 'managementTitleHeld',
  maritalStatus                            = 'married',
  maxClaimAmount                           = 'maxClaimAmount',
  maxLoanAmount                            = 'maxLoanAmount',
  maxLtvPercent                            = 'maxLtvPercent',
  maxLumpSum                               = 'maxLumpSum',
  message                                  = 'message',
  middleName                               = 'middleName',
  militaryExperience                       = 'militaryExperience',
  minLoanAmount                            = 'minLoanAmount',
  monthlyPayment                           = 'monthlyPayment',
  monthlyRent                              = 'monthlyRent',
  mortgageBalance                          = 'mortgageBalance',
  mortgageBalanceId                        = 'mortgageBalanceId',
  mothersMaidenName                        = 'mothersMaidenName',
  netPrincipalLimit                        = 'netPrincipalLimit',
  numOfDependent                           = 'numberOfDependents',
  dependentsAges                           = 'dependentsAges',
  numOfStructures                          = 'numberOfStructures',
  otherIncome                              = 'otherIncome',
  ownerAnnualPersonalIncome                = 'ownerAnnualPersonalIncome',
  ownerCity                                = 'ownerCity',
  ownerDateOfBirth                         = 'ownerDateOfBirth',
  ownerEmail                               = 'ownerEmail',
  ownerFirstName                           = 'ownerFirstName',
  ownerJobTitle                            = 'ownerJobTitle',
  ownerIsApplicant                         = 'ownerIsApplicant',
  ownerLastName                            = 'ownerLastName',
  ownerMiddleName                          = 'ownerMiddleName',
  ownerSuffixName                          = 'ownerSuffixName',
  ownerGuarantor                           = 'ownerGuarantor',
  ownerPercentage                          = 'ownerPercentage',
  ownerPersonalNetWorth                    = 'ownerPersonalNetWorth',
  ownerPhone                               = 'ownerPhone',
  ownerPropertyUsage                       = 'ownerPropertyUsage',
  ownerSinceYear                           = 'ownerSinceYear',
  ownerState                               = 'ownerState',
  ownerStreet                              = 'ownerStreet',
  ownerStreet2                             = 'ownerStreet2',
  ownerTitleHeld                           = 'ownerTitleHeld',
  ownerZip                                 = 'ownerZip',
  parcelId                                 = 'parcelId',
  pastNonAppropriations                    = 'pastNonAppropriations',
  pastNonAppropriationsExplanation         = 'pastNonAppropriationsExplanation',
  paymentFrequency                         = 'paymentFrequency',
  preferredPaymentDate                     = 'preferredPaymentDate',
  phone                                    = 'phone',
  prequalAmount                            = 'prequalAmount',
  prequalAmountYN                          = 'prequalAmountDesired',
  prequalExpiration                        = 'prequalExpiration',
  prequalIssued                            = 'prequalIssued',
  prequalLetterAmount                      = 'prequalLetterAmount',
  prequalRecalculate                       = 'prequalRecalculate',
  prequalSummary                           = 'prequalSummary',
  previousPropertyUsage                    = 'previousPropertyUsage',
  primaryBankCity                          = 'primaryBankCity',
  primaryBankName                          = 'primaryBankName',
  primaryBankOfficerName                   = 'primaryBankOfficerName',
  primaryBankOfficerPhone                  = 'primaryBankOfficerPhone',
  primaryBankState                         = 'primaryBankState',
  primaryBankStreet                        = 'primaryBankStreet',
  primaryBankStreet2                       = 'primaryBankStreet2',
  primaryBankZip                           = 'primaryBankZip',
  productType                              = 'productType',
  propertyAnnualAssociationAmount          = 'propertyAnnualAssociationAmount',
  propertyAnnualInsuranceAmount            = 'propertyAnnualInsuranceAmount',
  propertyAnnualRentAmount                 = 'propertyAnnualRentAmount',
  propertyAnnaulTaxAmount                  = 'propertyAnnualTaxAmount',
  propertyCity                             = 'propertyCity',
  propertyCounty                           = 'propertyCounty',
  propertyHasMortgage                      = 'propertyHasMortgage',
  propertyId                               = 'propertyId',
  propertyOriginalCost                     = 'propertyOriginalCost',
  propertyMonthlyRentalIncome              = 'propertyMonthlyRentalIncome',
  propertyState                            = 'propertyState',
  propertyStreet                           = 'propertyStreet',
  propertyStreet2                          = 'propertyStreet2',
  propertyTitleHeld                        = 'propertyTitleHeld',
  propertyType                             = 'propertyType',
  propertyTypeDesc                         = 'propertyTypeDesc',
  propertyUsage                            = 'propertyUsage',
  propertyValue                            = 'propertyValue',
  propertyZip                              = 'propertyZip',
  purchasePrice                            = 'purchasePrice',
  purchaseTimeline                         = 'purchaseTimeline',
  purpose                                  = 'purpose',
  isQuantumFileStarted                     = 'isQuantumFileStarted',
  quantumLoanId                            = 'quantumLoanId',
  quantumSimpleId                          = 'quantumSimpleId',
  race                                     = 'race',
  raceAsian                                = 'raceAsian',
  raceAsianOther                           = 'raceAsianOther',
  raceIslander                             = 'raceIslander',
  raceIslanderOther                        = 'raceIslanderOther',
  rate                                     = 'rate',
  realEstateLiabilities                    = 'realEstateLiabilities',
  realtorEmail                             = 'realtorEmail',
  realtorFirstName                         = 'realtorFirstName',
  realtorLastName                          = 'realtorLastName',
  realtorShare                             = 'realtorShare',
  redirectForm                             = 'redirectForm',
  referralId                               = 'referralId',
  relativeDOB                              = 'relativeDateOfBirth',
  relativeEmail                            = 'relativeEmail',
  relativeFirstName                        = 'relativeFirstName',
  relativeLastName                         = 'relativeLastName',
  relativeLivingPropertyCity               = 'relativeLivingPropertyCity',
  relativeLivingPropertyState              = 'relativeLivingPropertyState',
  relativeLivingPropertyStreet             = 'relativeLivingPropertyStreet',
  relativeLivingPropertyStreet2            = 'relativeLivingPropertyStreet2',
  relativeLivingPropertyZip                = 'relativeLivingPropertyZip',
  relativeMiddleName                       = 'relativeMiddleName',
  relativePhone                            = 'relativePhone',
  relativeSameAddress                      = 'relativeSameAddress',
  relativeSuffixName                       = 'relativeSuffixName',
  rentalCredit                             = 'rentalCredit',
  retirementIncome                         = 'retirementIncome',
  reverseMortgageLoanPurpose               = 'reverseMortgageLoanPurpose',
  reverseMortgageLoanType                  = 'reverseMortgageLoanType',
  scheduleDate                             = 'scheduleDate',
  schedulerEnabled                         = 'schedulerEnabled',
  scheduleTime                             = 'scheduleTime',
  selectedRate                             = 'selectedRate',
  sex                                      = 'sex',
  ssn                                      = 'ssn',
  ssnQuestionRequirement                   = 'ssnQuestionRequirement',
  startDate                                = 'startDate',
  suffixName                               = 'suffixName',
  taxExemptObligationsOver10M              = 'taxExemptObligationsOver10M',
  tenurePayment                            = 'tenurePayment',
  termPayment                              = 'termPayment',
  totalEquipmentCost                       = 'totalEquipmentCost',
  totalUpfrontCosts                        = 'totalUpfrontCosts',
  tradeInAmount                            = 'tradeInAmount',
  tradeInValue                             = 'tradeInValue',                               //auto-loan
  tradeReferenceCity                       = 'tradeReferenceCity',
  tradeReferenceContact                    = 'tradeReferenceContact',
  tradeReferenceEmail                      = 'tradeReferenceEmail',
  tradeReferenceName                       = 'tradeReferenceName',
  tradeReferencePhone                      = 'tradeReferencePhone',
  tradeReferenceState                      = 'tradeReferenceState',
  tradeReferenceStreet                     = 'tradeReferenceStreet',
  tradeReferenceStreet2                    = 'tradeReferenceStreet2',
  tradeReferenceZip                        = 'tradeReferenceZip',
  transferReasonCode                       = 'transferReasonCode',
  universalApplicationId                   = 'universalApplicationId',
  verifyAddress                            = 'verifyAddress',
  veteranLoanYN                            = 'veteranLoanYN',
  veteranYN                                = 'veteranYN',
  vehicle                                  = 'vehicle',
  vehicleBody                              = 'vehicleBody',
  vehicleCount                             = 'vehicleCount',
  vehicleId                                = 'vehicleId',
  vehicleMake                              = 'vehicleMake',
  vehicleModel                             = 'vehicleModel',
  vehicleMileage                           = 'vehicleMileage',
  vehicleNewOrUsed                         = 'vehicleNewOrUsed',
  vehicleType                              = 'vehicleType',
  vehicleYear                              = 'vehicleYear',
  vendorCity                               = 'vendorCity',
  vendorName                               = 'vendorName',
  vendorPhone                              = 'vendorPhone',
  vendorState                              = 'vendorState',
  vendorStreet                             = 'vendorStreet',
  vendorStreet2                            = 'vendorStreet2',
  vendorZip                                = 'vendorZip',
  wantsAutoInsurance                       = 'wantsAutoInsurance',
  yearAssociate                            = 'annualAssociation',
  yearInsure                               = 'annualInsurance',
  yearTaxes                                = 'annualTaxes',
}

export type FieldName = keyof typeof FieldNames;

export enum PropertyFieldNameType {
  SUBJECT_PROPERTY     = 'SUBJECT_PROPERTY',
  BORROWER_RESIDENCE   = 'BORROWER_RESIDENCE',
  COBORROWER_RESIDENCE = 'COBORROWER_RESIDENCE',
  RELATIVE_RESIDENCE   = 'RELATIVE_RESIDENCE'
}

export type PropertyFieldNameGroup = {
  city    : string;
  state   : string;
  street  : string;
  street2 : string;
  zip     : string;
}

export const getPropertyFieldNameGroup = (type: PropertyFieldNameType): PropertyFieldNameGroup => {
  const typeToGroupMap : Map<PropertyFieldNameType, PropertyFieldNameGroup> = new Map([
    [PropertyFieldNameType.SUBJECT_PROPERTY, {
      city    : FieldNames.propertyCity,
      state   : FieldNames.propertyState,
      street  : FieldNames.propertyStreet,
      street2 : FieldNames.propertyStreet2,
      zip     : FieldNames.propertyZip,
    }],
    [PropertyFieldNameType.BORROWER_RESIDENCE, {
      city    : FieldNames.livingPropertyCity,
      state   : FieldNames.livingPropertyState,
      street  : FieldNames.livingPropertyStreet,
      street2 : FieldNames.livingPropertyStreet2,
      zip     : FieldNames.livingPropertyZip,
    }],
    [PropertyFieldNameType.COBORROWER_RESIDENCE, {
      city    : FieldNames.coBorrowerLivingPropertyCity,
      state   : FieldNames.coBorrowerLivingPropertyState,
      street  : FieldNames.coBorrowerLivingPropertyStreet,
      street2 : FieldNames.coBorrowerLivingPropertyStreet2,
      zip     : FieldNames.coBorrowerLivingPropertyZip,
    }],
    [PropertyFieldNameType.RELATIVE_RESIDENCE, {
      city    : FieldNames.relativeLivingPropertyCity,
      state   : FieldNames.relativeLivingPropertyState,
      street  : FieldNames.relativeLivingPropertyStreet,
      street2 : FieldNames.relativeLivingPropertyStreet2,
      zip     : FieldNames.relativeLivingPropertyZip,
    }],
  ]);
  return typeToGroupMap.get(type);
};
